import styled, { css } from 'styled-components';

const HEADER_SIZE = {
  small: '16px',
  medium: '24px',
  large: '28px'
};

export const Wrapper = styled.div<{
  $headerSize: keyof typeof HEADER_SIZE;
  $backgroundColor?: string;
  $hoverable?: boolean;
  $special?: boolean;
  $headerClickable?: boolean;
  $padding?: string;
}>`
  width: 100%;
  padding: ${({ $padding }) => $padding ?? '18px'};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme, $backgroundColor }) => $backgroundColor ?? theme.colors.white};
  box-sizing: border-box;
  transition: outline-width 100ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 3px 0px;

  ${({ $special }) =>
    $special &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.purple6};
      background-color: ${({ theme }) => theme.colors.purple2};
    `}

  &:hover {
    outline: ${({ $hoverable, theme }) =>
      $hoverable ? `2px solid ${theme.colors.green6}` : 'none'};
  }

  .ant-divider-horizontal {
    margin: 0 0 16px 0;
  }

  & > div:first-of-type {
    font-family: ${({ theme }) => theme.fontFamily.primary};
    font-style: normal;
    font-weight: 600;
    font-size: ${({ $headerSize }) => HEADER_SIZE[$headerSize]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    display: flex;
    padding: 24px 24px 16px 24px;
    cursor: ${({ $headerClickable }) => ($headerClickable ? 'pointer' : 'auto')};
  }

  ${({ $headerClickable, theme }) =>
    $headerClickable &&
    css`
      & > div:first-of-type:hover {
        & > div:first-of-type {
          color: ${theme.colors.green6};
        }
        .addon-icon {
          transform: scaleX(1.2) scaleY(1.1);
          color: ${theme.colors.green6};
        }
        .addon-text {
          color: ${theme.colors.green6};
        }
      }
    `}
  & > section {
    height: 100%;
    &:hover {
      .activity-button {
        background-color: ${({ theme }) => theme.colors.green6};
        border: 1px solid ${({ theme }) => theme.colors.green6};
      }
    }
  }

  .subtitle {
    font-size: 12px;
  }
`;
